import { botLink } from '../domain/deepLink';
import { shareLink } from '../domain/invite';
import { appLink, type TelegramApi } from './webapp';

/** App settings get their own prefix so they never collide with the browser token (api/webSession.ts). */
const STORAGE_PREFIX = 'pass24.app.';

/**
 * The TelegramApi surface in an ordinary browser (#4218): features stay unaware of where they run. What only
 * Telegram can do degrades quietly — no phone sharing, no shortcut, no haptics; nested screens draw their own back
 * button (app/Shell.tsx), since there is no native one.
 */
export function createBrowserApi(win: Window = window): TelegramApi {
  const open = (url: string) => {
    win.open(url, '_blank', 'noopener');
  };
  const dark = typeof win.matchMedia === 'function' && win.matchMedia('(prefers-color-scheme: dark)').matches;
  return {
    messenger: null,
    name: 'Telegram',
    initData: '',
    colorScheme: dark ? 'dark' : 'light',
    platform: 'web',
    version: '',
    ready() {},
    requestContact: () => Promise.resolve(false),
    openLink: open,
    share: (link, text) => open(shareLink(link, text)),
    appLink: (startParam) => appLink(botLink(), startParam),
    notify() {},
    showBackButton: () => () => {},
    homeScreen: {
      status: () => Promise.resolve('unsupported'),
      add() {},
    },
    storage: {
      async get(key) {
        try {
          return win.localStorage.getItem(STORAGE_PREFIX + key);
        } catch {
          return null;
        }
      },
      async set(key, value) {
        try {
          win.localStorage.setItem(STORAGE_PREFIX + key, value);
        } catch {
          // Blocked storage: the setting is asked again next time.
        }
      },
    },
  };
}
